module.exports = ".ck.ck-editor__editable span[data-ck-hidden]{display:none}"